class PublishToMediaController {
    constructor($scope, mediaAccount,$filter, $state, modal, FileUploader, AppConfig, message, $http, ArticleAPI) {
        "ngInject";
        let self = this;
        this.mediaAccount = mediaAccount;
        this.$state = $state;
        this.modal = modal;
        this.loading = false;
        this.uploading = false;
        this.message = message;
        this.$http = $http;
        this.AppConfig = AppConfig;
        this.imageUploadPolicy = null;
        this.ArticleAPI = ArticleAPI;
        this.tranlsteFilter=$filter('translate');

        this.selectedMediaMap = {};
        this.selectedMedias = [];
        this.mediaOptions = {
            'weixin': {
                'send': false
            },
            'weibo': {},
            'toutiao': {
                'send': false
            }
        };

        this.formData = {
            id: this.original.id,
            type: this.originalType,
            cover_image: this.extractImage(),
            digest: this.original.outline,
        };

        this.emptyMedia = false;
        this.coverError = null;

        mediaAccount.init();
        let currentImageFilename = '';
        this.uploader = new FileUploader({
            autoUpload: true,
            removeAfterUpload: true,

            onSuccessItem: function (item, response, status, headers) {
                self.formData.cover_image = self.imageUploadPolicy['host'] + '/' + currentImageFilename;
                self.uploading = false;
            },
            onBeforeUploadItem: function (item) {

                $scope.sendForm.$setSubmitted();
                let size = item.file.size;
                self.coverError = null;
                if (size >= 2 * 1024 * 1024) {
                    self.uploader.cancelItem(item);
                    self.coverError = self.tranlsteFilter('page-original-text059');
                    return;
                }
                let type = item.file.type;
                if (["image/png", "image/jpeg", "image/bmp"].indexOf(type) == -1) {
                    self.uploader.cancelItem(item);
                    self.coverError= self.tranlsteFilter('page-original-text060');
                    return;
                }
                let fileSuffix = self.getSuffix(item.file.name);
                let filename = Date.now() + '_' + Math.floor(Math.random() * 1000);

                currentImageFilename = self.imageUploadPolicy['key'] + filename + fileSuffix;
                item.url = self.imageUploadPolicy['host'];
                item.formData = [
                    {
                        'key': currentImageFilename
                    },
                    {
                        'policy': self.imageUploadPolicy['policy']
                    },
                    {
                        'OSSAccessKeyId': self.imageUploadPolicy['accessid']
                    },
                    {
                        'success_action_status': '200'
                    },
                    {
                        'callback': ''
                    },
                    {
                        'signature': self.imageUploadPolicy['signature']
                    }
                ];
                self.uploading = true;
            }
        });
        this.getImageUploadPolicy();
    }

    extractImage() {
        let $content = $('<div>' + this.original.content + '</div>');

        let $images = $content.find('img');

        if ($images.length == 0) {
            return '';
        }

        for(let i=0, l=$images.length; i<l; i++)
        {
            let src = $($images[i]).attr('src');

            if(!/\.gif(\?.*)?/.test(src))
            {
                return src;
            }
        }

        return '';
    }

    show() {
        this.modal.open('publish-to-media-modal');
    }

    send(sendForm) {
        if (this.selectedMedias.length == 0) {
            this.emptyMedia = true;

        }
        sendForm.$setSubmitted();
        if (!sendForm.$valid) {
            return;
        }

        if (this.originalType == 'article' && this.formData.cover_image == '') {
            this.coverError = this.tranlsteFilter('modules-text018');
            return;
        }
        if (this.selectedMedias.length == 0) {
            return;

        }

        let self = this;
        this.formData.medias = this.selectedMedias;
        this.formData.options = this.mediaOptions;
        this.loading = true;

        this.$http.post(this.AppConfig.server_url + '/media/publish', this.formData, {
            withCredentials: true
        }).then(
            () => {
                self.loading = false;
                self.modal.close('publish-to-media-modal');
                self.message.success(self.tranlsteFilter('modules-text019'));
            },
            (response) => {
                self.loading = false;
                self.modal.close('publish-to-media-modal');
                self.message.error(response.data);
            }
        );
    }

    getImageUploadPolicy() {

        let self = this;

        this.ArticleAPI.one('image').one('policy').get().then(
            (policy) => {
                self.imageUploadPolicy = policy;
            },
            (response) => {
                self.message.error(response.data);
            }
        );
    }

    getSuffix(filename) {
        let pos = filename.lastIndexOf('.');
        if (pos != -1) {
            return filename.substring(pos)
        }
        return '';
    }

    selectMedia(name) {
        if (!this.mediaAccount.mediaAccounts[name] || !this.mediaAccount.mediaAccounts[name]['access_token'])
            return;

        if (this.selectedMediaMap[name]) {
            let idx = this.selectedMedias.indexOf(name);
            this.selectedMedias.splice(idx, 1);
            delete this.selectedMediaMap[name];
        } else {
            this.selectedMedias.push(name);
            this.selectedMediaMap[name] = 1;
        }
    }

    toggleOption(media, option) {
        if (!this.selectedMediaMap[media])
            return;

        this.mediaOptions[media][option] = !this.mediaOptions[media][option];
    }

    gotoBind() {
        this.modal.close('publish-to-media-modal');
        this.$state.go('app.home.profile.media');
    }
}
export default PublishToMediaController;



// WEBPACK FOOTER //
// ./src/app/modules/publish-to-media/publish-to-media.controller.js